import React, { useContext } from "react";
import { GlobalLoaderContext } from "../utils/GlobalLoaderContext";
import {
  CloseCircleFilled,
  SyncOutlined,
} from "@ant-design/icons";
import "../globalLoader.css";
const GlobalLoader = () => {
  const { loading, percent, stopLoadingCross, message, loadingCount } =
    useContext(GlobalLoaderContext);
  const clampedPercent = Math.max(0, Math.min(100, Number(percent) || 0));
  const statusText = message || "Updating accounts";
  const supportingText = message || "Your financial data is syncing in the background";

  // if (!loading) return null;

  return (
    <div className={`global-loader-container ${loading ? "show" : ""}`}>
      <div className="global-loader-body">
        <div className="global-loader-header">
          <div className="global-loader-header-left">
            <div className="global-loader-icon">
              <SyncOutlined spin />
            </div>
            <div style={{ minWidth: 0 }}>
              <div className="global-loader-title">{statusText}</div>
              <div className="global-loader-subtitle">{supportingText}</div>
            </div>
          </div>
          <span onClick={stopLoadingCross} className="global-loader-close">
            <CloseCircleFilled />
          </span>
        </div>
        <div className="global-loader-track" aria-hidden="true">
          <div
            className="global-loader-fill"
            style={{ width: `${clampedPercent}%` }}
          />
        </div>
        <div className="global-loader-footer">
          <span>
            {message ? "Progress continues while we finalize updates" : "Progress is being updated live"}
          </span>
          <span className="global-loader-percent">{clampedPercent}%</span>
        </div>
        <div className="global-loader-footer" style={{ marginTop: 0 }}>
          <span>Active jobs</span>
          <span className="global-loader-percent">{loadingCount}</span>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader;
